import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(6),

}));

export default StyledBox;
